<template>
  <svg
    width="52"
    height="52"
    viewBox="0 0 52 52"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      y="0.00146484"
      width="52"
      height="52"
      rx="26"
      fill="#166ED4"
      fill-opacity="0.1"
    />
    <g clip-path="url(#clip0_1951_210387)">
      <path
        d="M27.125 24.5015V24.8765H27.5H34.5C34.7984 24.8765 35.0845 24.995 35.2955 25.206C35.5065 25.4169 35.625 25.7031 35.625 26.0015C35.625 26.2998 35.5065 26.586 35.2955 26.797C35.0845 27.0079 34.7984 27.1265 34.5 27.1265H27.5H27.125V27.5015V34.5015C27.125 34.7998 27.0065 35.086 26.7955 35.297C26.5845 35.5079 26.2984 35.6265 26 35.6265C25.7016 35.6265 25.4155 35.5079 25.2045 35.297C24.9935 35.086 24.875 34.7998 24.875 34.5015V27.5015V27.1265H24.5H17.5C17.2016 27.1265 16.9155 27.0079 16.7045 26.797C16.4935 26.586 16.375 26.2998 16.375 26.0015C16.375 25.7031 16.4935 25.417 16.7045 25.206C16.9155 24.995 17.2016 24.8765 17.5 24.8765H24.5H24.875V24.5015V17.5015C24.875 17.2031 24.9935 16.9169 25.2045 16.706C25.4155 16.495 25.7016 16.3765 26 16.3765C26.2984 16.3765 26.5845 16.495 26.7955 16.706C27.0065 16.9169 27.125 17.2031 27.125 17.5015V24.5015ZM26 6.37646C36.8389 6.37646 45.625 15.1626 45.625 26.0015C45.625 36.8404 36.8389 45.6265 26 45.6265C15.1611 45.6265 6.375 36.8404 6.375 26.0015C6.375 15.1626 15.1611 6.37646 26 6.37646ZM26 8.62646C21.3919 8.62646 16.9725 10.457 13.714 13.7155C10.4556 16.9739 8.625 21.3933 8.625 26.0015C8.625 30.6096 10.4556 35.029 13.714 38.2874C16.9725 41.5459 21.3919 43.3765 26 43.3765C30.6081 43.3765 35.0275 41.5459 38.286 38.2874C41.5444 35.029 43.375 30.6096 43.375 26.0015C43.375 21.3933 41.5444 16.9739 38.286 13.7155C35.0275 10.457 30.6081 8.62646 26 8.62646Z"
        fill="#0F285B"
        stroke="white"
        stroke-width="0.75"
      />
    </g>
    <defs>
      <clipPath id="clip0_1951_210387">
        <rect
          width="40"
          height="40"
          fill="white"
          transform="translate(6 6.00146)"
        />
      </clipPath>
    </defs>
  </svg>
</template>